import { render, staticRenderFns } from "./ResponsablesDetails.vue?vue&type=template&id=675a966c&"
import script from "./ResponsablesDetails.vue?vue&type=script&lang=js&"
export * from "./ResponsablesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports